import { render, staticRenderFns } from "./customerform.vue?vue&type=template&id=cb982d64&scoped=true&"
import script from "./customerform.vue?vue&type=script&lang=js&"
export * from "./customerform.vue?vue&type=script&lang=js&"
import style0 from "./customerform.vue?vue&type=style&index=0&id=cb982d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb982d64",
  null
  
)

export default component.exports